'use client';

import Link from 'next/link';
import { WaveformBars } from '@/components/waveform-bars';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const errorRef = `#ERR-${Date.now()}`;

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-4"
      style={{ background: 'var(--background, #FAF9F6)' }}
    >
      {/* Logo */}
      <div className="mb-10 flex items-center gap-2">
        <WaveformBars bars={3} height={16} />
        <span
          className="text-base font-bold"
          style={{ color: 'var(--green-900, #004322)', fontFamily: 'var(--font-display)' }}
        >
          trustbox
        </span>
      </div>

      {/* Error icon */}
      <div
        className="mb-8 flex h-12 w-12 items-center justify-center rounded-full"
        style={{ background: 'var(--danger, #DC2626)' }}
      >
        <span className="text-xl font-bold text-white">!</span>
      </div>

      {/* Text */}
      <h1
        className="text-[28px] font-bold font-[family-name:var(--font-heading)]"
        style={{ color: 'var(--text, #1C1917)' }}
      >
        Something went wrong
      </h1>
      <p
        className="mt-2 text-[15px]"
        style={{ color: 'var(--text-secondary, #57534E)' }}
      >
        We&apos;ve been notified and are looking into it.
      </p>

      {/* Buttons */}
      <div className="mt-8 flex items-center gap-3">
        <button
          onClick={reset}
          className="inline-flex items-center justify-center rounded-full px-6 text-sm font-semibold text-white transition-opacity hover:opacity-90"
          style={{
            height: 52,
            background: 'var(--green-900, #004322)',
          }}
        >
          Try Again
        </button>
        <Link
          href="/"
          className="inline-flex items-center justify-center rounded-full border-2 px-6 text-sm font-semibold transition-opacity hover:opacity-90"
          style={{
            height: 52,
            borderColor: 'var(--border, #EBE8E3)',
            color: 'var(--text-secondary, #57534E)',
          }}
        >
          Go Home
        </Link>
      </div>

      {/* Error reference */}
      <p
        className="mt-12 font-[family-name:var(--font-mono)] text-[11px]"
        style={{ color: 'var(--text-muted, #9CA3AF)' }}
      >
        Error reference: {errorRef}
      </p>
    </div>
  );
}
